import { Component, OnInit } from '@angular/core';
import { StudyService } from 'src/app/shared-new/services/study.service';

@Component({
  selector: 'app-study-files',
  templateUrl: './study-files.component.html',
  styleUrls: ['./study-files.component.scss'],
})
export class StudyFilesComponent implements OnInit {
  constructor(private studyService: StudyService) {}

  ngOnInit(): void {}
}
